module.exports = __webpack_public_path__ + "img/_DSC7772-min-min.1a2a1b03.jpg";